import * as React from "react";
import type { SVGProps } from "react";
const SvgRss = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4 10a1 1 0 1 0 0 2zm8 10a1 1 0 1 0 2 0zM4 3a1 1 0 0 0 0 2zm15 17a1 1 0 1 0 2 0zM4 12a8 8 0 0 1 5.657 2.343l1.414-1.414A10 10 0 0 0 4 10zm5.657 2.343A8 8 0 0 1 12 20h2a10 10 0 0 0-2.929-7.071zM4 5a15 15 0 0 1 10.607 4.393L16.02 7.98A17 17 0 0 0 4 3zm10.607 4.393A15 15 0 0 1 19 20h2a17 17 0 0 0-4.98-12.02zM5 19v2a2 2 0 0 0 2-2zm0 0H3a2 2 0 0 0 2 2zm0 0v-2a2 2 0 0 0-2 2zm0 0h2a2 2 0 0 0-2-2z"
    />
  </svg>
);
export default SvgRss;
